// 飞镖列表
const dartsList = 'special/specialColumnList';
// 飞镖详情
const dartsInfo = 'special/specialColumnInfo';
export {
  dartsList,
  dartsInfo
}